<template>
  <div @click="onApple">
    <slot></slot>
  </div>
</template>

<script>
/* global AppleID */
import { LOGIN_APPLE } from "../../apis/user"
export default {
  computed: {
    i18n() {
      return this.$t("login")
    }
  },
  data() {
    return {
      appleScriptLoaded: false
    }
  },
  methods: {
    onApple() {
      if (!this.appleScriptLoaded) {
        this.$toast("Loading...")
        return
      }
      this.$loading(true)
      AppleID.auth
        .signIn()
        .then((res) => {
          if (res.authorization && res.authorization.code) {
            this.loginByApple({
              authorizationCode: res.authorization.code,
              identityToken: res.authorization.idToken,
              user: res.user ? JSON.stringify(res.user) : ""
            })
          } else {
            this.$loading(false)
            this.$toast(this.i18n.msg_fail_login)
          }
        })
        .catch((err) => {
          console.log("Apple sign in error:", err)
          this.$loading(false)
          if (err && err.error === "popup_closed_by_user") {
            // 用户取消
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        })
    },
    loginByApple(params) {
      this.$post(
        LOGIN_APPLE,
        params,
        (resp) => {
          this.$loading(false)
          const _data = resp.data || resp || {}
          if (_data.token) {
            this.$store.commit("token", _data.token)
            this.$emit("success")
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (error) => {
          console.log(error)
          this.$loading(false)
          this.$toast(this.i18n.msg_fail_login)
        }
      )
    },
    initApple() {
      try {
        AppleID.auth.init({
          clientId: process.env.VUE_APP_APPLEID,
          scope: "name email",
          redirectURI: window.location.href,
          state: "apple_login",
          usePopup: true
        })
        this.appleScriptLoaded = true
      } catch (err) {
        console.warn("initApple ~ err:", err)
      }
    },
    loadApple(d, s, id) {
      let js = ""
      let fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = "https://appleid.apple.com/auth/js/appleauth.js"
      js.onload = () => {
        this.initApple()
      }
      fjs.parentNode.insertBefore(js, fjs)
    }
  },
  mounted() {
    if (document.getElementById("apple-jsplatform")) {
      this.initApple()
    } else {
      this.loadApple(document, "script", "apple-jsplatform")
    }
  }
}
</script>
